import React from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import Select from "../../form/Select";

class LocationSectionForm extends React.Component<any, any> {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            storeType="local"
                            value={this.props.values.parent_type}
                            options={this.props.locationComponents}
                            objectValue={false}
                            name="parent_type"
                            label="Hol"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-md-6">
                        {this.props.values.parent_type && <Select
                            storeType="remote"
                            value={this.props.values.parent_id}
                            component={this.props.values.parent_type}
                            label={this.props.locationComponents.find((option) => option.id === this.props.values.parent_type)?.label}
                            name="parent_id"
                            objectValue={false}
                            saveChanges={this.props.setFieldValue}
                        />}
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LocationSectionForm);
